exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1 !important;\n  background-color: #000; }\n\n#ModalValidaEsqueciMinhaSenha {\n  background-color: #00000073; }\n\n#ModalCadastro {\n  background-color: #00000073; }\n\n.btn-consultar-processos {\n  font-size: 16px !important;\n  color: #333; }\n\n.btn-consultar-processos:disabled {\n  cursor: not-allowed !important; }\n\n.page-loader-wrapper-processos {\n  background: rgba(0, 0, 0, 0.2) !important; }\n  .page-loader-wrapper-processos p {\n    color: #fff !important;\n    text-shadow: 1px 1px #000; }\n\n@media (min-width: 992px) {\n  #ModalConsultaProcessos .modal-dialog {\n    position: absolute;\n    width: 50%;\n    left: 50%;\n    margin-left: 60px;\n    margin-top: 120px;\n    margin-top: calc(120px + 10vh); } }\n\ninput {\n  text-transform: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/login/login.component.scss
// module id = ../../../../../src/app/login/login.component.scss
// module chunks = main